import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sbuild__item sbuild__item--clickable"
}
const _hoisted_2 = { class: "sbuild__main-content" }
const _hoisted_3 = { class: "sbuild__name" }
const _hoisted_4 = { class: "sbuild__data-block" }
const _hoisted_5 = { class: "sbuild__data-class" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "sbuild__data-stats" }
const _hoisted_9 = { class: "sbuild__data-stat" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sbuild__data-separator" }, "-", -1)
const _hoisted_11 = { class: "sbuild__data-stat" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sbuild__data-separator" }, "-", -1)
const _hoisted_13 = { class: "sbuild__data-stat" }
const _hoisted_14 = {
  key: 0,
  class: "sbuild__author-block"
}
const _hoisted_15 = { class: "sbuild__author-block-right" }
const _hoisted_16 = { class: "sbuild__author-name" }
const _hoisted_17 = { class: "sbuild__author-date" }
const _hoisted_18 = {
  key: 1,
  class: "sbuild__author-block"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "sbuild__author-block-right" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "sbuild__author-name" }, "Пользователь не найден"),
  /*#__PURE__*/_createElementVNode("p", { class: "sbuild__author-date" }, "—")
], -1)
const _hoisted_20 = { class: "sbuild__info-col" }
const _hoisted_21 = { class: "sbuild__icons-top" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "sbuild__icon-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sbuild__icon-main" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "20",
      height: "16",
      viewBox: "0 0 20 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: "sbuild__likes-svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M9.62064 2.29822C9.71563 2.40892 9.85422 2.47262 10.0001 2.47262C10.146 2.47262 10.2846 2.40892 10.3795 2.29822C12.042 0.360759 14.697 -0.164272 16.7433 1.53117C18.8279 3.25825 19.0829 6.18754 17.4711 8.25512C16.761 9.16591 15.3047 10.6111 13.8175 12.0104C12.3398 13.4007 10.8626 14.7173 10.1329 15.3615C10.0911 15.3983 10.0585 15.4271 10.0298 15.4516C10.0158 15.4637 10.004 15.4736 9.99388 15.4818C9.96318 15.4567 9.92162 15.4203 9.85502 15.3615L9.85497 15.3615C9.12523 14.7173 7.64801 13.4007 6.17037 12.0104C4.68313 10.6111 3.22682 9.16591 2.51676 8.25513C0.90935 6.19323 1.19206 3.2793 3.24966 1.5268L2.92546 1.14615L3.24966 1.5268C5.25246 -0.179029 7.95452 0.35653 9.62064 2.29822Z",
        fill: "#a5a5a5",
        stroke: "#a5a5a5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1)
const _hoisted_23 = { class: "sbuild__likes-amount" }
const _hoisted_24 = {
  key: 0,
  class: "tooltip-anchor"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "Видна всем пользователям", -1)
const _hoisted_26 = { class: "sbuild__card" }
const _hoisted_27 = {
  key: 1,
  class: "tooltip-anchor"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Видна только вам", -1)
const _hoisted_29 = { class: "sbuild__card" }
const _hoisted_30 = {
  key: 2,
  class: "tooltip-anchor"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "Сборка является копией", -1)
const _hoisted_32 = { class: "sbuild__card" }
const _hoisted_33 = { class: "sbuild__icons-bottom" }
const _hoisted_34 = {
  key: 0,
  class: "tooltip-anchor"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Удалить", -1)
const _hoisted_36 = { class: "sbuild__card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconMobility = _resolveComponent("IconMobility")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!
  const _component_IconGlobe = _resolveComponent("IconGlobe")!
  const _component_IconEyeSlash = _resolveComponent("IconEyeSlash")!
  const _component_IconCopy = _resolveComponent("IconCopy")!
  const _component_IconTrash = _resolveComponent("IconTrash")!
  const _directive_shiny_border = _resolveDirective("shiny-border")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.isFinishedLoading && _ctx.loadedUserData)
    ? _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.hasLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: /build/ + _ctx.item.dbId,
              target: "_blank",
              class: "sbuild__link"
            }, null, 8, ["to"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.item.data.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.item.soldierClass !== 'custom')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("img", {
                      src: 
									require('@/assets/soldier_icons/' +
										_ctx.getSoldierData('id', _ctx.item.soldierClass, 'icon'))
								,
                      alt: "",
                      class: "sbuild__data-icon"
                    }, null, 8, _hoisted_6),
                    _createElementVNode("p", null, _toDisplayString(_ctx.getSoldierData('id', _ctx.item.soldierClass, 'name')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("img", {
                      src: require('@/assets/soldier_icons/tags.svg'),
                      alt: "",
                      class: "sbuild__data-icon"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("p", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.tags, (tag, idx) => {
                        return (_openBlock(), _createElementBlock("span", { key: tag }, _toDisplayString(_ctx.convertSkillTagToName(tag)) + _toDisplayString(idx + 1 < _ctx.item.tags.length ? ', ' : ''), 1))
                      }), 128))
                    ])
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_IconBase, {
                  iconColor: '#94FF94',
                  width: 14,
                  height: 14
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconMobility)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.item.stats[0]), 1)
              ]),
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_IconBase, {
                  iconColor: '#FF9494',
                  width: 14,
                  height: 14
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconMobility)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.item.stats[1]), 1)
              ]),
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_IconBase, {
                  iconColor: '#FFFF94',
                  width: 14,
                  height: 14
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconMobility)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.item.stats[2]), 1)
              ])
            ])
          ]),
          (
						(_ctx.loadedUserData &&
							Object.keys(_ctx.loadedUserData).length > 0 &&
							_ctx.loadedUserData.photoURL !== null &&
							_ctx.loadedUserData.displayName !== null &&
							String(_ctx.loadedUserData.avatarProvider) === 'google') ||
						'gravatar' ||
						'none'
					)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_UserAvatar, {
                  "photo-u-r-l": String(_ctx.loadedUserData.photoURL),
                  "display-name": String(_ctx.loadedUserData.displayName),
                  "email-hash": String(_ctx.loadedUserData.emailHash) || '',
                  "avatar-provider": _ctx.loadedUserData.avatarProvider || 'google',
                  class: "sbuild__author-avatar"
                }, null, 8, ["photo-u-r-l", "display-name", "email-hash", "avatar-provider"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.loadedUserData.displayName), 1),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(new Date(
										_ctx.item.data.createdAt.seconds * 1000
									).toLocaleDateString()), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_UserAvatar, {
                  "photo-u-r-l": 'https://place-hold.it/80x80/8c8f94/8c8f94.jpg',
                  "avatar-provider": 'google',
                  class: "sbuild__author-avatar"
                }, null, 8, ["photo-u-r-l"]),
                _hoisted_19
              ]))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["sbuild__likes-block", { active: _ctx.isLikedByCurrentUser }])
            }, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.likesAmountOnLoad), 1)
            ], 2),
            (_ctx.isStatusVisible)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.item.data.isPublic)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_TooltipComponent, {
                          direction: 'left',
                          width: 22
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                            default: _withCtx(() => [
                              _createVNode(_component_IconGlobe)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_component_TooltipComponent, {
                          direction: 'left',
                          width: 22
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                            default: _withCtx(() => [
                              _createVNode(_component_IconEyeSlash)
                            ]),
                            _: 1
                          })
                        ])
                      ])),
                  (_ctx.item.data.isCloned)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_TooltipComponent, {
                          direction: 'left',
                          width: 22
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                            default: _withCtx(() => [
                              _createVNode(_component_IconCopy)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.isStatusVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_TooltipComponent, {
                    direction: 'left',
                    width: 10
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconTrash)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])), [
        [_directive_shiny_border, {
				height: 2,
				padding: 12,
				hoverRgbaColor: [51, 51, 51, 0.76],
			}],
        [_directive_ripple]
      ])
    : _createCommentVNode("", true)
}